import Input from "../../../Atoms/Input";
import {DropDown} from "../../../Atoms/DropDown";
import React, {useEffect} from "react";
import {useAppDispatch, useAppSelector} from "../../../redux/hooks";
import {RootState} from "../../../redux/store";
import {setCharacter, setCharacterValues} from "../../../redux/slices/character/characterSlice";
import Button from "../../../Atoms/Button";
import {SaveSharp} from "@mui/icons-material";
import {useMutation, useQuery} from "@apollo/client";
import {GetCharacter4User, GetValues4CharacterCreation} from "../../../GraphQL/CharacterQueries";
import {setIsAppLoading} from "../../../redux/slices/content/contentSlice";
import {CreateCharacter, CreateCharacterSheet} from "../../../GraphQL/CharacterMutation";
import {toast} from "react-toastify";

export const CharacterCreateMask = () => {
    const dispatch = useAppDispatch();
    const character = useAppSelector((state: RootState) => state.character);
    const adventure = useAppSelector((state: RootState) => state.adventure);
    const user = useAppSelector((state: RootState) => state.user);

    const [ classId, setClassId ] = React.useState<number>(0);
    const [ hasSubclassRestriction, setHasSubclassRestriction ] = React.useState<boolean>(false);
    const [ subClassId, setSubClassId ] = React.useState<number>(0);
    const [ raceId, setRaceId ] = React.useState<number>(0);
    const [ subraceId, setSubraceId ] = React.useState<number>(0);

    const [ classes, setClasses ] = React.useState<any[]>([]);
    const [ subclasses, setSubclasses ] = React.useState<any[]>([]);
    const [ races, setRaces ] = React.useState<any[]>([]);
    const [ subraces, setSubraces ] = React.useState<any[]>([]);

    const {
        data: charCreationData,
        error: charCreationError,
        loading: charCreationLoading
    } = useQuery(GetValues4CharacterCreation, {
        fetchPolicy: 'network-only'
    })

    const [
        createCharacterSheetHook, {
            data: createCharacterSheetData,
            loading: createCharacterSheetLoading,
            error: createCharacterSheetError
        } ] = useMutation(CreateCharacterSheet)

    const [
        createCharacterHook, {
            data: createCharacterData,
            loading: createCharacterLoading,
            error: createCharacterError
        } ] = useMutation(CreateCharacter)

    useEffect(() => {
        if (charCreationData && !charCreationLoading) {
            dispatch(setIsAppLoading({isAppLoading: true, loadingText: 'Lade verfügbare Klassen und Völker...'}))

            const classList = []
            const raceList = []

            raceList.push({
                itemText: 'Noch kein Volk ausgewählt',
                itemValue: 0,
            })
            classList.push({
                itemText: 'Noch keine Klasse ausgewählt',
                itemValue: 0
            })

            for (const entry of charCreationData.getClasses) {
                classList.push({
                    itemText: entry.className,
                    itemValue: Number(entry.classId),
                })
            }
            setClasses(classList);
            for (const entry of charCreationData.getRaces) {
                raceList.push({
                    itemText: entry.raceName,
                    itemValue: Number(entry.raceId)
                })
            }
            setRaces(raceList);

            dispatch(setIsAppLoading({isAppLoading: false, loadingText: ''}))
        }
    }, [ charCreationData ])

    useEffect(() => {
        if (charCreationLoading) {
            dispatch(setIsAppLoading({isAppLoading: true, loadingText: 'Lade verfügbare Klassen und Völker...'}))
        } else {
            dispatch(setIsAppLoading({isAppLoading: false, loadingText: ''}))
        }
    }, [ charCreationLoading ])

    useEffect(() => {
        if (createCharacterLoading) {
            dispatch(setIsAppLoading({isAppLoading: true, loadingText: 'Erstelle gerade den Charakter...'}))
        } else {
            dispatch(setIsAppLoading({isAppLoading: false, loadingText: ''}))
        }
    }, [ createCharacterLoading ])

    useEffect(() => {
        if (createCharacterSheetLoading) {
            dispatch(setIsAppLoading({isAppLoading: true, loadingText: 'Erstelle gerade den Charakter...'}))
        } else {
            dispatch(setIsAppLoading({isAppLoading: false, loadingText: ''}))
        }
    }, [ createCharacterSheetLoading ])

    const handleSetClass = (classId: number) => {
        if (classId > 0) {
            const index = charCreationData.getClasses.findIndex((entry: any) => Number(entry.classId) === classId)
            const subclassList = [];
            subclassList.push({
                itemText: 'Noch keine Subklasse ausgewählt',
                itemValue: 0
            })

            if (charCreationData.getClasses[index].subclassLevel === 1) {
                setHasSubclassRestriction(false)
                for (const subclass of charCreationData.getClasses[index].Subclass) {
                    subclassList.push({
                        itemText: subclass.subclassName,
                        itemValue: Number(subclass.subclassId)
                    })
                }
            } else {
                setHasSubclassRestriction(true)
            }

            setSubclasses(subclassList)
            setClassId(classId);
        } else {
            setClassId(classId);
        }

    }

    const handleSetRace = (raceId: number) => {
        if (raceId > 0) {
            const index = charCreationData.getRaces.findIndex((entry: any) => Number(entry.raceId) === raceId)
            const subraceList = [];
            subraceList.push({
                itemText: 'Noch kein Subvolk ausgewählt',
                itemValue: 0
            })

            for (const subclass of charCreationData.getRaces[index].Subrace) {
                subraceList.push({
                    itemText: subclass.subraceName,
                    itemValue: Number(subclass.subraceId)
                })
            }

            setSubraces(subraceList)
            setRaceId(raceId);
        } else {
            setRaceId(raceId);
        }
    }

    const handleSaveCharacter = async () => {
        const saveSubclassId = subClassId === 0 ? null : subClassId
        const characterResponse = await createCharacterHook({
            variables: {
                characterName: character.characterName,
                raceId: raceId,
                subraceId: subraceId,
                userId: Number(user.userId),
                adventureId: Number(adventure.adventureId),
                subclassId: saveSubclassId,
                classId: classId,
            }
        })

        if (!characterResponse.errors) {
            const response = await createCharacterSheetHook({
                variables: {
                    characterId: Number(characterResponse.data.createCharacter.characterId),
                    languages: "",
                    spellAttackModifier: 0,
                    spellSaveDc: 0,
                    lifepoints: 0,
                    armorClass: 0,
                    initiative: 0
                },
                refetchQueries: [
                    {
                        query: GetCharacter4User,
                        variables: {userId: Number(user.userId), adventureId: Number(adventure.adventureId)}
                    } ]
            })

            if (response.errors) {
                toast('Es gab einen Fehler beim Erstellen des Charakterbogens')
            } else {
                toast('Charakter erfolgreich erstellt')
            }
        } else {
            toast('Es gab einen Fehler beim Erstellen des Charakters')
        }
    }

    return (
        <div className='row'>
            <div className='row justify-content-end'>
                <div className='col-2'>
                    <Button onClick={async () => await handleSaveCharacter()}><SaveSharp/> Erstellen</Button>
                </div>
            </div>
            <div className='col-11'>
                <h6>Fange an indem du einen Charakter erstellst!</h6>
            </div>
            <div className='col-11'>
                <Input onChange={(e: any) => dispatch(setCharacterValues({
                    characterId: character.characterId,
                    characterName: e.target.value
                }))} label='Charaktername:'/>
            </div>
            <div className='col-11 mt-5'>
                <DropDown label='Klasse:' value={classId}
                          setValue={(event) => handleSetClass(Number(event.target.value))}
                          items={classes}/>
            </div>
            {(classId > 0 && hasSubclassRestriction) && (
                <div className='col-11 mt-5'>
                    <label>Die Subklasse ist erst ab höherer Stufe verfügbar</label>
                </div>
            )}
            {classId > 0 && (
                <div className='col-11 mt-5'>
                    <DropDown label='Subklasse:' value={subClassId}
                              setValue={(event) => setSubClassId(Number(event.target.value))} items={subclasses}
                              disabled={hasSubclassRestriction}/>
                </div>
            )}
            <div className='col-11 mt-5'>
                <DropDown label='Volk:' value={raceId} setValue={(event) => handleSetRace(Number(event.target.value))}
                          items={races}/>
            </div>
            {raceId > 0 && (
                <div className='col-11 mt-5'>
                    <DropDown label='Subvolk:' value={subraceId}
                              setValue={(event) => setSubraceId(Number(event.target.value))}
                              items={subraces}/>
                </div>
            )}
        </div>
    )
}